import React from 'react';
import cn from 'classnames';
import './SegmentedControl.scss';

/**
 * @typedef {Object} TabOption
 * @property {string} label - The label text for the tab
 * @property {string} [mobileLabel] - The label text for mobile devices
 * @property {boolean} isActive - Whether this tab is currently active
 * @property {boolean} [isDisabled] - Whether this tab is disabled
 * @property {() => void} onClick - Function to call when tab is clicked
 */

/**
 * @typedef {Object} SegmentedControlProps
 * @property {TabOption[]} tabOptions - Array of tab options to display
 * @property {React.ReactNode} [children] - Child elements to render
 */

/**
 * A segmented control component that displays tabs with an animated background
 * @param {SegmentedControlProps} props - Component props
 * @returns {React.ReactElement} The segmented control component
 */
const SegmentedControl = ({ tabOptions, children }) => {
  const numTabsClass = `num-tabs-${tabOptions.length}`;

  return (
    <div className={cn('segmented-control', numTabsClass)}>
      {children}

      {tabOptions.map((option, index) => {
        const { label, isDisabled, isActive } = option;
        return (
          <div className={cn('tab-option', numTabsClass, { active: isActive, disabled: isDisabled })} onClick={option.onClick} key={index}>
            <div className='label'>{label}</div>
            <div className='mobile-label'>{option.mobileLabel}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
